import { render, staticRenderFns } from "./kpi.vue?vue&type=template&id=33f3ebf4&"
import script from "./kpi.vue?vue&type=script&lang=js&"
export * from "./kpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports